export default {
  system: {
    project_name: "SAE Access Health System",
    loading: "Loading...",
    empty_data: "No data...",
    version: "Version",
    submitting_feeback: "Please wait...",
    update_button: "Update",
    edit_button: "Edit",
    sending_feeback: "Sending..."
  },
  common: {
    created: "Created",
    sites: "Location",
    events: "Events",
    assets: "Users",
    campaigns: "Campaigns",
    option_select_site: "Please select a location",
    option_select_asset: "Please select an user",
    site: "Location",
    asset: "User",
    event: "Event",
    type: "Type",
    temperature: "Temperature",
    location: "Location",
    last_location: "Last Location",
    value: "Value",
    longitude: "Longitude",
    latitude: "Latitude",
    name: "Name",
    status: "Status",
    response: "Response",
    label_last_check: "Last Check",
    label_last_seen: "Last Seen",
    key: "Key",
    phone: "Phone",
    time: "Time",
    distance: "Distance Variation",
    start_date: "Start",
    end_date: "End",
    help: "Help",
    action: "Action",
    back: "Back",
    remove: "Remove"
  },
  nav: {
    sites: "Locations",
    campaigns: "Campaigns",
    assets: "Users",
    events: "Events",
    help: "Help"
  },
  auth: {
    login_prompt: "Don't have an account?",
    register_prompt: "Already have an account?",
    login_text: "Log in",
    register_text: "Sign Up",

    login_title: "Account Log In",
    register_title: "Register for an account",
    interest_title: "Register your interest",
    login_button: "Login",
    logout_button: "Logout",
    register_button: "Register Account",
    interest_button: "Register",

    label_email: "Email",
    input_email_placeholder: "Enter email",
    label_password: "Password",
    input_password_placeholder: "Enter password",
    label_firstname: "First Name",
    input_firstname_placeholder: "Enter your first name",
    label_lastname: "Last name",
    input_lastname_placeholder: "Enter your last name",

    form_email_invalid_error: "Invalid email address format",
    form_email_required_error: "Email is required",
    form_password_invalid_error: "Password must be 3 characters at minimum",
    form_password_required_error: "Password is required",
    from_firstname_invalid_error: "First name must be at least 2 letters",
    form_firstname_required_error: "First name is required",
    from_lastname_invalid_error: "Last name must be at least 2 letters",
    form_lastname_required_error: "Last name is required",
    interest_prompt: "Interested in this platform?",
    interest_text: "Register your interest",
    interest_success_msg:
      "Thank you for your interest, we will get back to you shortly"
  },
  site: {
    list_title: "Locations",
    create_title: "Create New Location",
    update_title: "Update Location",
    create_button: "Create Location",

    label_name: "Name",
    label_latitude: "Latitude",
    label_longitude: "Longitude",
    label_notes: "Notes",

    form_name_invalid_error: "Site name must be at least 2 letters",
    form_name_required_error: "Site name is required"
  },
  campaign: {
    list_title: "Isolation Campaigns",
    create_title: "Create Campaign",
    update_title: "Update Campaign",
    items_title: "All Recipients",
    items: "Recipients",
    items_title_flagged: "Flagged Recipients",
    create_button: "Create Campaign",
    label_name: "Campaign Name",
    label_dates: "Dates",
    label_sms_message: "SMS Message Example",
    form_site_required_error: "Site is required",
    form_name_required_error: "Campaign name is required",
    form_name_invalid_error: "Campaign name must be at least 2 letters",
    send_sms_to_all_button: "Send SMS to All",
    send_sms_to_all_confirm_msg:
      "Are you sure you want to send SMS to your all recipients?",
    send_sms_button: "Send SMS",
    send_confirm_msg: "Are you sure you want to send SMS?",
    campaign_detail_events: "Reported Locations",
    edit_items_button: "Edit Recipients",
    edit_campaign_button: "Edit Campaign",
    status_pending: "Pending",
    status_active: "Sending",
    status_paused: "Paused",
    status_complete: "Complete",

    item_status_pending: "Pending",
    item_status_active: "Sending",
    item_status_exempt: "Exempt",
    item_status_complete: "Complete",

    item_response_status_pending: "Pending",
    item_response_status_located: "Actioned",
    item_response_status_exception: "Investigate",
    item_response_status_complete: "Complete",

    item_add_button: "Add Recipient",
    item_remove_confirm_msg: "Are you sure you want to remove this item ?"
  },
  event: {
    list_title: "My Events",
    create_title: "Create Event",
    create_button: "Create Event",
    label_recent_events: "Recent Events",
    form_asset_required_error: "User is required",
    form_site_required_error: "Site is required",
    label_last_check: "Last Check",
    trigger_prompt: "This event is triggered from",
    type_temperature: "Temperature",
    type_location: "location"
  },
  asset: {
    list_title: "My Users",
    create_title: "Create User",
    update_title: "Update User",
    create_button: "Create User",
    import_title: "Import Users",
    import_button: "Import Users",
    upload_button: "Upload",
    label_recent_assets: "Recent Users",
    label_name: "Name",
    input_name_placeholder: "Enter User Name",
    label_phone: "Phone",
    label_image: "Image",
    label_encoding: "Encoding",
    label_hash: "Hash",
    label_csv_file: "CSV File",

    form_site_required_error: "Site is required",
    form_name_required_error: "User name is required",
    form_name_invalid_error: "User name must be at least 2 letters"
  },
  help: {
    title: "Help",
    concepts_title: "Concepts",
    concepts_content_p1:
      "The system is designed to use SMS and Geolocation to enforce self isolation.",
    concepts_content_p2:
      "The system will send SMS periodically to users requesting them to verify that they are self isolating. Users' location (in latitude and longitude) will be displayed on the campaign page. A user that has high degree of movement will be flagged for further investigation.",
    concepts_content_p3_1:
      'The system uses "Location" to provide a logical grouping of Users.',
    concepts_content_p3_2:
      'The system uses "Users" to describe people that should be in isolation.',
    concepts_content_p3_3:
      'The system uses "Events" to describe something that occured to an User, a Location Event for example.',
    concepts_content_p3_4:
      'The system uses "Campaigns" to provide a logical grouping of SMS campaigns to Users.',
    sms_campaign_title: "Creating an SMS campaign",
    campaign_location: "Create a location",
    campaign_location_introduce:
      "a location to group campaigns and usersCreate a location",
    campaign_import: "Import users",
    campaign_import_introduce:
      "import names and phone numbers, a template is provided below",
    campaign_create: "Create a campaig",
    campaign_create_introduce:
      "all users in the location will be attached to the campaign automatically, SMS will be scheduled automatically once the campaign is created, you can manage the campaign via the campaign page.",
    campaign_status_title: "Campaign Status",
    campaign_status_pending: "Pending",
    campaign_status_pending_introduce: "The campaign is set up and ready",
    campaign_status_active: "Active",
    campaign_status_active_introduce:
      "The system is sending SMS to all the users in the campaign",
    campaign_status_complete: "Complete",
    campaign_status_complete_introduce:
      "The system has sent all SMS and the campaign end date has reached",
    system_introduce_title: "How does the system work?",
    system_introduce_content:
      "Users will receive an SMS requesting the user to open up a webpage. The webpage will use a smart phone's native geolocation capabilities to send the person's location to the server. The location of these individuals will be displayed in the campaign page. The system does not enforce the user has to be in a certain location. The system only needs to verify the person's location has not changed since the last check-in. When the current location is different to the previous location, the user will be flagged for further investigation. Different is described as \"the previous location is at least 1KM away from the current location\".",

    csv_template_title: "CSV Template",
    csv_template_promt_start: "You can download an",
    csv_template_promt_end: "example template here.",
    contact_title: "Contact",
    contact_promt:
      "You can reach our customer service at https://pellar.zendesk.com"
  }
};
